import { put, takeLatest, all, call } from 'redux-saga/effects';
import { setAction } from '../actions/billingHistoryPage';
import actionTypes from '../../../redux/actions/action-types';
import {
  getTeamBillingAdjustmentsWithTeamid,
  getTeamSubscriptionsWithTeamid,
  getTeamInvoiceWithTeamidAndInvoice,
} from '../../../api/cloudApiGenerated';

export function* getAdjustments(params) {
  let { team, adjustments } = params.data;

  if (typeof adjustments !== 'undefined') {
    yield put(
      setAction({
        dataReturned: true,
      })
    );
    return;
  }

  try {
    let data = yield call(getTeamBillingAdjustmentsWithTeamid, team.id);
    yield put(
      setAction({
        dataReturned: true,
        adjustments: data.data,
      })
    );
  } catch (error) {
    yield put(
      setAction({
        error: 'loading billing history: ' + error && (error.message || error.toString()),
      })
    );
  }
}

export function* getSubHistory(params) {
  let { team, subscriptions } = params.data;

  if (typeof subscriptions !== 'undefined') {
    yield put(
      setAction({
        dataReturned: true,
      })
    );
    return;
  }

  try {
    const data = yield call(getTeamSubscriptionsWithTeamid, team.id);
    yield put(
      setAction({
        subscriptions: data.data,
        dataReturned: true,
      })
    );
  } catch (error) {}
}

export function* downloadInvoice(params) {
  let { team, invoiceNumber } = params.data;

  try {
    yield call(getTeamInvoiceWithTeamidAndInvoice, team.id, invoiceNumber);
  } catch (error) {
    yield put(
      setAction({
        error: 'downloading Invoice: ' + error && (error.message || error.toString()),
      })
    );
  }
}

export function* watchGetAdjustments() {
  yield takeLatest(actionTypes.billingHistoryPage.getAdjustments, getAdjustments);
}
export function* watchGetSubHistory() {
  yield takeLatest(actionTypes.billingHistoryPage.getSubHistory, getSubHistory);
}

export function* watchDownloadInvoice() {
  yield takeLatest(actionTypes.billingHistoryPage.downloadInvoice, downloadInvoice);
}

export default function* rootSaga() {
  yield all([watchGetAdjustments(), watchGetSubHistory(), watchDownloadInvoice()]);
}
